<template>
  <div id="app" :class="[
      lang === 'en' && 'en-app',
      ((pathName && pathName.split('/')[1]) || 'home') + '-page',
    ]">
    <div class="main" v-show="!isShowLoading">
      <NavBar />
      <router-view />
    </div>
    <Loading v-show="isShowLoading" />
    <Toast />
  </div>
</template>

<script>
import Loading from '@/components/Loading.vue'
import Toast from '@/components/Toast.vue'

import { mapState, mapMutations } from 'vuex'

export default {
  computed: {
    ...mapState([
      'lang',
      'isShowLoading',
      'pathName',
      'toastData',
      'hisLen'
    ])
  },
  watch: {
    $route (to, from) {
      const lan = to.query.lan || 'zh'
      if (to.path != from.path || lan != this.lang) {
        this.setShowLoading(true)
      }
      //   if (to.path != from.path) {
      //     this.setShowLoading(true)
      // }
      this.setLang(lan)
      this.$i18n.locale = lan
      this.setPathName(to.path)
      const userInfo = localStorage.getItem('userInfo')
        ? JSON.parse(localStorage.getItem('userInfo'))
        : ''
      this.setUserInfo(userInfo)
      this.$Common.httpToPc(to.path, lan)
      this.setHisLen(this.hisLen + 1)
      window.scrollY = 0
    },
    toastData (val) {
      if (val) {
        setTimeout(() => {
          this.setToastData(null)
        }, 3000)
      }
    },
    isShowLoading (val) {
      if (!val) {
        clearTimeout(window.timeoutIds)
      }
    },
    lang (val) {
      if (val === 'en') {
        document.title =
          'National Digital Economy Innovation and Development Pilot Zone (Sichuan) Comprehensive Information Platform'
      } else {
        document.title =
          '四川互联网违法和不良信息举报平台'
      }
    }
  },
  components: {
    Loading,
    Toast
  },
  mounted () {
    window.$toast = this.$toast
    this.$nextTick(() => {
      if (this.lang === 'en') {
        document.title =
          'National Digital Economy Innovation and Development Pilot Zone (Sichuan) Comprehensive Information Platform'
      } else {
        document.title =
          '四川互联网违法和不良信息举报平台'
      }
    })
    window.addEventListener('pageshow', e => {
      if (e.persisted) {
        window.location.reload()
      }
    })
    this.$Api.userGet({}, { noToast: true }).then(res => {
      if (!res) localStorage.setItem('userInfo', '')
    }).catch(() => {
      localStorage.setItem('userInfo', '')
    })
  },
  methods: {
    ...mapMutations([
      'setLang',
      'setPathName',
      'setShowLoading',
      'setToastData',
      'setUserInfo',
      'setHisLen'
    ])

  },
  created () {

  }
}
</script>

<style lang="scss">
#app {
  font-family: MicrosoftYaHei;
  // margin-top: 10.463vw;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
  .main {
    height: 88%;
    margin-top: 20.93vw;
  }
  &.login-page {
    background-color: #1b33a7;
    .main {
      height: 100%;
    }
  }
  &.atlas-page {
    // background-color: #000;
    .main {
      height: 100%;
    }
  }
  input::-webkit-input-placeholder {
    /* WebKit browsers */
    color: rgba(191, 191, 191, 1) !important;
  }

  input::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: rgba(191, 191, 191, 1) !important;
  }

  input:-ms-input-placeholder {
    /* Internet Explorer 10+ */
    color: rgba(191, 191, 191, 1) !important;
  }
}
</style>
